// ─── View-only pages refuse saves ────────────────────────────────────────────
// A collaborator with Read on a page can open it but not change anything on
// it. The page guard (components/AccessGuard.js) registers what the page on
// screen allows, and every write path (erpApi requests, kiosk write actions,
// the store's write endpoints) asks here before anything leaves the browser.
// No check registered (signed out, an owner, a page they may write on) means
// every save goes through, exactly as before.

let check = null;

/** Register the current page's rule: fn({ path, method, body }) returns a
 *  reason to refuse, or nothing to allow. null clears it. */
export function setWriteCheck(fn) {
    check = typeof fn === 'function' ? fn : null;
}

export const VIEW_ONLY_MESSAGE = 'View only. You can look at this page but not change it.';

/** Throws before a refused write is sent. */
export function assertCanWrite(request = {}) {
    if (!check) return;
    const reason = check(request);
    if (!reason) return;
    const err = new Error(typeof reason === 'string' ? reason : VIEW_ONLY_MESSAGE);
    err.code = 'view_only';
    err.status = 403;
    throw err;
}
